import React from "react";
import { DisabledPrompt, Link, useGlobalController, BCMSRecord, Branding } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView, TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { SVGAsset } from "res";
import { Message, MessageCategory } from "model";

import "./styles.css";
import MobileMessagesTable from "./components/MobileMessagesTable";

/**
 * @function MessagesPage
 * @return {React.Component}
 * @exported true
 * @description The main component for MessagesPage.
 */
export default function MessagesPage(props) {  
  const controller = useGlobalController();
  BCMSRecord.globalControllerFor([ Message, MessageCategory ], controller);

  const messages = Message.initAll().map(message => <MessageTableRow key={ `Message_${ message.id }` } item={ message } />, []);

  return (
    <PageContainer className="messages-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Messages" />
          <div className="content-container">
            <Branding id="compose_new_abi22" value="true">
              <DisabledPrompt>
                  <Link>Compose New</Link>
                </DisabledPrompt>
            </Branding>
          </div>
          <div className="show-on-desktop">
            <TableView>
              <TableColumnContainer>
                <TableColumnView className="text-left subject-column" text="Subject" />
                <TableColumnView className="text-left tracking-id-column" text="Tracking ID" />
                <TableColumnView className="text-left created-column" text="Created" />
                <TableColumnView className="text-left last-updated-column" text="Last Updated" icon="ArrowDownIcon" />
                <TableColumnView className="text-left category-column" text="Category" />
                <TableColumnView className="trash-can-x-column" text="" />
              </TableColumnContainer>

              <TableBody>
                { messages }
              </TableBody>
            </TableView>
          </div>
          <div className="show-on-mobile">
            <MobileMessagesTable />
          </div>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}

/**
 * @function MessageTableRow 
 * @param {STRING} message - Sets the message text. 
 * @param {STRING} trackingId  - Sets the tracking Id.
 * @param {STRING} dateTime - Sets the date and time.
 * @param {STRING} lastUpdated - Sets the last updated date and time.
 * @param {STRING} catergory - Sets the catergory name. 
 * @return {React.Component}
 * @exported false
 * @description The main component for MessageTableRow 
 */
function MessageTableRow(props) {
  const message = props.item ?? Message.firstInstanceOf();

  const createdDate = `${ message.createdDate.format("m/d/Y") } ${ message.createdTime }`;
  const updatedDate = `${ message.updatedDate.format("m/d/Y") } ${ message.updatedTime }`;

  return (
    <TableItemContainer>
      <TableItemTextView className="message-text" text={<DisabledPrompt><Link>{ message.message }</Link></DisabledPrompt>} />
      <TableItemTextView className="tracking-id-text" text={ message.trackingID } />
      <TableItemTextView className="date-time-text" text={ createdDate } />
      <TableItemTextView className="last-updated-text" text={ updatedDate }/>
      <TableItemTextView className="category-text" text={ message.category.description } />
      <TableItemView className="icon-item text-center clickable">
        <DisabledPrompt>
          <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon" />
        </DisabledPrompt>
      </TableItemView>
    </TableItemContainer>
  )
}